import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import EmailChipsInput from '../../pages/alertManager/email-chip-input';

import { Icon, Switch, Tooltip } from '@controlrooms/components';
import { ICONS } from '@controlrooms/constants';

const TitleWrapper = styled.div`
  font-size: 13px;
  display: flex;
  align-items: center;
  p {
    margin: 0px;
    margin-left: 10px;
  }
`;
export const AlertEmails = () => {
  const { setValue, watch, setError, clearErrors } = useFormContext();

  const sendViaEmail = watch('alert_destination.email_destination.selected');
  const emails: string[] = watch('alert_destination.email_destination.emails');

  const validate = (isSwitchOn: boolean = sendViaEmail, list: string[] = emails) => {
    if (list.length) {
      clearErrors(['alert_destination.email_destination']);
    } else if (isSwitchOn && !list.length) {
      setError('alert_destination.email_destination', {
        type: 'custom',
        message: 'Emails are required',
      });
    }
  };

  return (
    <>
      <TitleWrapper>
        <Switch
          selected={sendViaEmail}
          dataTestId={'teams'}
          onClick={() => {
            validate(!sendViaEmail);
            setValue('alert_destination.email_destination.selected', !sendViaEmail);
          }}
        />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p style={{ marginRight: '5px' }}>Email</p>
          <Tooltip label={'Send alerts via email'} place="right" className="duration-info">
            <Icon name={ICONS.Info} />
          </Tooltip>
        </div>
      </TitleWrapper>
      {sendViaEmail && <EmailChipsInput validate={validate} />}
    </>
  );
};
